import {  Col, DatePicker, Button } from "antd";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { currentDateStartTime, currentDateEndTime, dateTimeFormat, formatToCompanyTimezone, toCompanyDateOnlyforReportDateFilter } from "../../lib/functions";

const RecordDateFilter = ({ filters, handleFilterChange }) => {
  const setQuickRange = (range) => {
  const today = dayjs(); 
  let fromDate, toDate;

  switch (range) {
    case "last7days":
      fromDate = currentDateStartTime(
        today.subtract(6, "day").format("YYYY-MM-DD")
      );
      toDate = currentDateEndTime(
        dayjs().format("YYYY-MM-DD")
      );
      break;

    case "thisMonth":
      fromDate = currentDateStartTime(
        today.startOf("month").format("YYYY-MM-DD")
      );
      toDate = currentDateEndTime(
        today.endOf("month").format("YYYY-MM-DD")
      );
      break;

    default: // today
      fromDate = currentDateStartTime(
        today.format("YYYY-MM-DD")
      );
      toDate = currentDateEndTime(
        today.format("YYYY-MM-DD")
      );
  }

  handleFilterChange("fromDate", fromDate);
  handleFilterChange("toDate", toDate);
};


  return (
    <>
      {/* From Date */}
      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
        <label className="form-label-nowrap">
          <span style={{ color: "#ff4d4f" }}>*</span> From Date
        </label>
        <DatePicker
          value={filters.fromDate ? toCompanyDateOnlyforReportDateFilter(filters.fromDate) : null}
          data-testid="from-datepicker"
          size="large"
          onChange={(v) => {
            if (!v) {
              handleFilterChange("fromDate", null);
              return;
            }
            const dateStr = v.format("YYYY-MM-DD"); // ✅ key fix
            const isoStart = currentDateStartTime(dateStr);
            if (filters.toDate && dayjs(isoStart).isAfter(dayjs(filters.toDate))) {
              Swal.fire({
                icon: "warning",
                title: "Invalid Date",
                text: "From Date cannot be after To Date.",
              });
              return;
            }
            handleFilterChange("fromDate", isoStart);
          }}
          style={{ width: "100%" }}
          format={dateTimeFormat}
        />
      </Col>

      {/* To Date */}
      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
        <label className="form-label-nowrap">
          <span style={{ color: "#ff4d4f" }}>*</span> To Date
        </label>
        <DatePicker
          size="large"
          value={filters.toDate ? toCompanyDateOnlyforReportDateFilter(filters.toDate) : null}
          data-testid="to-datepicker"
          onChange={(v) => {
            if (!v) {
              handleFilterChange("toDate", null);
              return;
            }
            const dateStr = v.format("YYYY-MM-DD"); // ✅ key fix
            const isoEnd = currentDateEndTime(dateStr);
            if (filters.fromDate && dayjs(isoEnd).isBefore(dayjs(filters.fromDate))) {
              Swal.fire({
                icon: "warning",
                title: "Invalid Date",
                text: "To Date cannot be before From Date.",
              });
              return;
            }

            handleFilterChange("toDate", isoEnd);
          }}
          style={{ width: "100%" }}
          format={dateTimeFormat}
        />
      </Col>

      {/* Quick Buttons */}
      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
  <label className="form-label-nowrap" >Quick Range</label>
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "8px",
      width: "100%",
    }}
  >
    <Button block size="small" onClick={() => setQuickRange("today")}>
      Today
    </Button>
    <Button block size="small" onClick={() => setQuickRange("last7days")}>
      Last 7 Days
    </Button>
    <Button block size="small" onClick={() => setQuickRange("thisMonth")}>
      This Month
    </Button>
  </div>
</Col>

    </>
  );
};

export default RecordDateFilter;
